module.exports = __webpack_public_path__ + "static/img/icon_promotion_view_cnt.c0b1367.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_promotion_view_cnt.svg
// module id = aWYw
// module chunks = 10